<template>
  <div class="pdf-upload">

    <div class="my-upload-list" style="ling-height:100px;" v-for="(item, index) in uploadList" :key="'upload' + index">
      <template v-if="item.status === 'finished'">
        <img :src="item.url" style="
            width: 100px;
            height: 100px;" />
        <div class="my-upload-list-cover" style="line-height:100px;">
          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
          <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
        </Spin>
      </template>
    </div>

    <Upload v-show="!uploadList.length" ref="pdfUpLoad" :show-upload-list="false" :on-success="handleSuccess" :format="['pdf']" :max-size="maxSize" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl" style="display: inline-block;">
      <div style="width:100px;height:100px;padding-top: 15px;color:rgb(133, 133, 133);">
        <div style="font-size:25px;">+<p style="font-size:14px;text-align:center;">上传文件</p>
        </div>
      </div>
    </Upload>
    <p class="upload-p" style="width: 100%;font-size: 12px;color: #4d4d4d;">{{config.remind}}</p>
    <p class="upload-p" style="width: 100%;font-size: 12px;color: #4d4d4d;" v-if="config.tip">{{config.tip}}</p>

    <iModal title="预览" cancel-text v-model="visible">
      <div style="text-align: center;">
        <img :src="imgName.url" style="max-width: 100%" />
      </div>
    </iModal>

  </div>
</template>

<script>
import configJson from '@assets/config.json';
import { mapActions } from 'vuex'
export default {
  name: 'pdfUpLoad',
  props: {
    config: {
      default () {
        return {
          id: "pdfUpLoad",
          headers: {},
          format: ["pdf"],
          "max-size": 50,
          remind: "(文件要求：文件大小不超过5M,仅支持PDF格式)",
          limitNum: 1,
          tip: "",
        };
      }
    },
    fileList: {
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      uploadUrl: `${configJson.api.reqApi}/api/CtyunOSS/files`,
      visible: false,
      imgName: "",
      uploadList: [],
    }
  },
  computed: {
    maxSize () {
      return this.config["max-size"] * 1024;
    },
    formatText () {
      return this.config.format.join(",");
    },
    uploadC () {
      return this.$refs['pdfUpLoad'];
    },
  },
  methods: {
    ...mapActions({
      pdfToImages: 'hostCommonModule/pdfToImages',
    }),
    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove (file) {
      this.uploadList.splice(this.uploadList.indexOf(file), 1);
      if (this.uploadList.length === 0) {
        this.uploadList = this.uploadC.fileList = [];
      }
      this.$emit("file-ok", this.outList(this.uploadList));
    },
    // 上传成功
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.pdfToImagesHandle(file.url);
      }
    },
    outList (res) {
      //传出数据
      let list = [];
      res.map(c => {
        list.push({
          url: c,
          link: { type: "-1", value: "" },
          title: ""
        });
      });
      console.log([{
        picture: {
          list: list,
          padding: 0,
          spacing: 0,
          type: 1,
        }
      }]);
      return [{
        picture: {
          list: list,
          padding: 0,
          spacing: 0,
          type: 1,
        }
      }];
    },
    // 文件格式错误
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: `请上传${this.formatText}的文件`
      });
    },
    // 上传失败
    handleUploadError (file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
    },
    // 文件过大
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: `请上传小于5M的文件`
      });
    },
    // 上传数量
    handleBeforeUpload (e) {
      let limitNum = this.config.limitNum;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}个文件`
        });
      }
      return check;
    },
    initUploadList () {
      this.uploadList.splice(0, this.uploadList.length);
      for (let item of this.fileList) {
        if (item.src) {
          this.uploadList.push({
            status: "finished",
            url: item.url,
            src: item.src
          });
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
        }
      }
    },
    clearFiles () {
      this.uploadList = this.uploadC.fileList = [];
    },
    async pdfToImagesHandle (url) {
      let res = await this.pdfToImages(url);
      if (res && res.successed) {
        this.$emit("file-ok", this.outList(res.images));
        this.uploadList = [];
        res.images.forEach(c => {
          this.uploadList.push({ status: "finished", url: c });
        });
      } else {
        if (res.errors && res.errors[0].code === -1) {
          this.$Message.error("请上传10页以内的文件!");
        } else {
          this.$Message.error("上传失败，请重新尝试!");
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-upload {
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>